import { render } from "./Potential.vue?vue&type=template&id=d62aa6b8"
import script from "./Potential.vue?vue&type=script&lang=js"
export * from "./Potential.vue?vue&type=script&lang=js"

import "./Potential.vue?vue&type=style&index=0&id=d62aa6b8&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__